import KycAggregation from "./KycAggregation";
export default KycAggregation;
